import { hooks } from 'lib_ui-primitives';

const { useFeatureFlags } = hooks;
export const _private = { useFeatureFlags };

export default function useHasFeatureFlag(flag) {
    return _private.useFeatureFlags()?.includes(flag) ?? false;
}
